export default () => ({
	data: [],
	personalStats: [],
	processing: false
})
